import React, { Component } from 'react'
import styled from 'styled-components'
import { CHILDREN_STATUS_SMALL_DIV } from '../../Constants'


const ImgDiv = styled.div`
  background-image: ${props => props.profile_image ? 'url(' + props.profile_image + ')' : 'url(/assets/BabyAvatar.svg)' };
  background-size: cover;
  background-position: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border:  solid #CCCCCC 1px;
  @media (max-width: 763px) {
    width: 50px;
    height: 50px;
  }
`

const BlanckDiv = styled.div`
  background-color: white;
  border-radius: 50%;
  height:15px;
  width:15px;
  margin: 28px 0px 0px 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 763px) {
    width: 20px;
    height: 20px;
    margin: 30px 0px 0px 30px;
  }
`
const StatusDiv = styled.div`
  background-color: ${props => CHILDREN_STATUS_SMALL_DIV[props.type]};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height:11px;
  width:11px;
  @media (max-width: 763px) {
    width: 15px;
    height: 15px;
  }
`
const Img = styled.img`
width: 8px;
height: 8px;
@media (max-width: 763px) {
  width: 10px;
  height: 10px;
}
`

class ProfilePicture extends Component {

  render(){
    return (
      <ImgDiv profile_image = {this.props.profile_image}>
        <BlanckDiv>
          <StatusDiv type = {this.props.type}>
            { this.props.type === "Nurse's Room" || this.props.type === "Virtual Center - Nurse's Room"  ? <Img src='assets/NursesRoom.svg' alt='type' /> : '' }
            { this.props.type === "Home" ? <Img src='assets/home_icon.svg' alt='type' /> : '' }
          </StatusDiv>
        </BlanckDiv>
      </ImgDiv>
    )
  }
}


export default ProfilePicture



// WEBPACK FOOTER //
// ./src/Components/ChildrenList/ProfilePicture.jsx